import React from 'react';
import { FaCheck } from 'react-icons/fa';
import './Toggle.css';

function Toggle({ checked, onChange, label, disabled }) {
  return (
    <label className={`vx-toggle ${checked ? 'checked' : ''} ${disabled ? 'disabled' : ''}`}>
      <input
        type="checkbox"
        checked={!!checked}
        onChange={(e) => onChange && onChange(e.target.checked)}
        disabled={disabled}
      />
      <span className="vx-toggle-track">
        <span className="vx-toggle-knob">
          {checked && <FaCheck className="vx-toggle-check" />}
        </span>
      </span>
      {label && <span className="vx-toggle-label">{label}</span>}
    </label>
  );
}

export default Toggle; 